export default "__VITE_ASSET__IxWYZdKp__"